/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantWarrantDto } from '../models/PagedResultDto_ParticipantWarrantDto';
import type { PagedResultDto_ParticipantWarrantExerciseHistoryDto } from '../models/PagedResultDto_ParticipantWarrantExerciseHistoryDto';
import type { Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseDto } from '../models/Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseDto';
import type { Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseResultDto } from '../models/Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseResultDto';
import type { Wealthlane_CapTable_Dtos_Warrant_ParticipantExercisableWarrantsDto } from '../models/Wealthlane_CapTable_Dtos_Warrant_ParticipantExercisableWarrantsDto';
import type { Wealthlane_CapTable_Dtos_Warrant_WarrantExerciseRequestDto } from '../models/Wealthlane_CapTable_Dtos_Warrant_WarrantExerciseRequestDto';
import type { Wealthlane_CapTable_Dtos_Warrant_WarrantVestingScheduleDto } from '../models/Wealthlane_CapTable_Dtos_Warrant_WarrantVestingScheduleDto';
import type { Wealthlane_CapTable_Enums_WarrantInstrumentStatus } from '../models/Wealthlane_CapTable_Enums_WarrantInstrumentStatus';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WarrantParticipantService {

    /**
     * @param status 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantWarrantDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantParticipantParticipantWarrantList(
status?: Wealthlane_CapTable_Enums_WarrantInstrumentStatus,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantWarrantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-participant/participant-warrant-list',
            query: {
                'Status': status,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param warrantId 
     * @returns Wealthlane_CapTable_Dtos_Warrant_ParticipantExercisableWarrantsDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantParticipantExercisableWarrants(
warrantId: string,
): CancelablePromise<Wealthlane_CapTable_Dtos_Warrant_ParticipantExercisableWarrantsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-participant/exercisable-warrants/{warrantId}',
            path: {
                'warrantId': warrantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiCapTableApiAppWarrantParticipantRequestExercise(
requestBody?: Array<Wealthlane_CapTable_Dtos_Warrant_WarrantExerciseRequestDto>,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cap-table/api/app/warrant-participant/request-exercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseResultDto OK
     * @throws ApiError
     */
    public static postApiCapTableApiAppWarrantParticipantCalculateExercise(
requestBody?: Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseDto,
): CancelablePromise<Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cap-table/api/app/warrant-participant/calculate-exercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param warrantId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantWarrantExerciseHistoryDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantParticipantExerciseHistory(
warrantId?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantWarrantExerciseHistoryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-participant/exercise-history',
            query: {
                'WarrantId': warrantId,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param warrantId 
     * @returns Wealthlane_CapTable_Dtos_Warrant_WarrantVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantParticipantParticipantWarrantVestingSchedule(
warrantId: string,
): CancelablePromise<Array<Wealthlane_CapTable_Dtos_Warrant_WarrantVestingScheduleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-participant/participant-warrant-vesting-schedule/{warrantId}',
            path: {
                'warrantId': warrantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
